<form class="f-col blank-form" [formGroup]="preferenceinfoForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managetraveler.preferences']}} <div class="dot">.</div> <span
                class="optional">{{content?.['b2b.managetraveler.optional']}}</span></h2>
        <button type="button" class="link" (click)="Editpersonal()"
            *ngIf="hasFormData && Loader.isEditableClicked"><mat-icon
                fontSet="material-symbols-outlined" class="edit-icon">edit</mat-icon>
            {{content?.['b2b.managetraveler.edit']}}</button>
    </div>

    <div class="section-content">
        <div class="inner-contentsection"
            [class.view-disabled]="(hasFormData && Loader.isEditableClicked)">
            <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.selectlonghaul']}}</mat-label>
                        <mat-icon *ngIf="preferenceinfoForm.get('seatingPref')?.value && !Loader.isEditableClicked" fontSet="material-symbols-outlined" matSuffix class="close-icon" style="cursor: pointer; font-size: 20px; width: 20px; height: 20px;" (click)="$event.stopPropagation(); preferenceinfoForm.get('seatingPref')?.setValue('')">close</mat-icon>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select"
                            [ngStyle]="{color: preferenceinfoForm.get('seatingPref')?.value ? 'green' : 'gray'}">stat_minus_1</mat-icon>
                        <mat-select autoBlurSelect formControlName="seatingPref">
                            <mat-option *ngFor="let seat of commonObjPipes.seatingPref.pipe" [value]="seat"> {{
                                seat }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.selectshorthaul']}}</mat-label>
                        <mat-icon *ngIf="preferenceinfoForm.get('shorthaulSeatingPref')?.value && !Loader.isEditableClicked" fontSet="material-symbols-outlined" matSuffix class="close-icon" style="cursor: pointer; font-size: 20px; width: 20px; height: 20px;" (click)="$event.stopPropagation(); preferenceinfoForm.get('shorthaulSeatingPref')?.setValue('')">close</mat-icon>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select"
                            [ngStyle]="{color:preferenceinfoForm.get('shorthaulSeatingPref')?.value ? 'green':'gray'}">stat_minus_1</mat-icon>
                        <mat-select formControlName="shorthaulSeatingPref">
                            <mat-option *ngFor="let seat of commonObjPipes.shorthaulSeatingPref.pipe"
                                [value]="seat"> {{ seat }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.selectmeal']}}</mat-label>
                        <mat-icon *ngIf="preferenceinfoForm.get('mealPref')?.value && !Loader.isEditableClicked" fontSet="material-symbols-outlined" matSuffix class="close-icon" style="cursor: pointer; font-size: 20px; width: 20px; height: 20px;" (click)="$event.stopPropagation(); preferenceinfoForm.get('mealPref')?.setValue('')">close</mat-icon>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select"
                            [ngStyle]="{color:preferenceinfoForm.get('mealPref')?.value ? 'green':'gray'}">stat_minus_1</mat-icon>
                        <input type="text" matInput formControlName="mealPref" [matAutocomplete]="automeal"
                            (input)="filterControls('mealPref',$event,'MealDescription')"
                            (keypress)="_CommonService.blockInvalidCharacters($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)">
                        <mat-autocomplete #automeal="matAutocomplete"
                            (optionSelected)="filterControls('mealPref',$event.option.value,'MealDescription')">
                            <mat-option *ngFor="let meal of commonObjPipes.mealPref.pipe"
                                [value]="meal.MealDescription"> {{ meal.MealDescription }} </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.selectstop']}}</mat-label>
                        <mat-icon *ngIf="preferenceinfoForm.get('prefStopover')?.value && !Loader.isEditableClicked" fontSet="material-symbols-outlined" matSuffix class="close-icon" style="cursor: pointer; font-size: 20px; width: 20px; height: 20px;" (click)="$event.stopPropagation(); preferenceinfoForm.get('prefStopover')?.setValue('')">close</mat-icon>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select"
                            [ngStyle]="{color:preferenceinfoForm.get('prefStopover')?.value ? 'green':'gray'}">stat_minus_1</mat-icon>
                        <mat-select formControlName="prefStopover">
                            <mat-option *ngFor="let stop of commonObjPipes.prefStopover.pipe" [value]="stop"> {{
                                stop }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.selectmax']}}</mat-label>
                        <mat-icon *ngIf="preferenceinfoForm.get('prefMaxLayout')?.value && !Loader.isEditableClicked" fontSet="material-symbols-outlined" matSuffix class="close-icon" style="cursor: pointer; font-size: 20px; width: 20px; height: 20px;" (click)="$event.stopPropagation(); preferenceinfoForm.get('prefMaxLayout')?.setValue('')">close</mat-icon>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select"
                            [ngStyle]="{color:preferenceinfoForm.get('prefMaxLayout')?.value ? 'green':'gray'}">stat_minus_1</mat-icon>
                        <mat-select formControlName="prefMaxLayout">
                            <mat-option *ngFor="let layover of commonObjPipes.prefMaxLayout.pipe"
                                [value]="layover"> {{ layover }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managetraveler.selectclass']}}</mat-label>
                        <mat-icon *ngIf="preferenceinfoForm.get('prefClass')?.value && !Loader.isEditableClicked" fontSet="material-symbols-outlined" matSuffix class="close-icon" style="cursor: pointer; font-size: 20px; width: 20px; height: 20px;" (click)="$event.stopPropagation(); preferenceinfoForm.get('prefClass')?.setValue('')">close</mat-icon>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select"
                            [ngStyle]="{color:preferenceinfoForm.get('prefClass')?.value ? 'green':'gray'}">stat_minus_1</mat-icon>
                        <mat-select formControlName="prefClass">
                            <mat-option *ngFor="let classPref of commonObjPipes.prefClass.pipe"
                                [value]="classPref"> {{ classPref }} </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row">
                <div class="fill-manually cm-fill-manually">
                    <div class="f-col">
                        <ng-container
                            *ngIf="(Loader.isEditableClicked && !!selectedPreferences.length) else otherPrefEditElse">
                            <span class="chip-label">{{content?.['b2b.managetraveler.addotherpref']}}</span>
                        </ng-container>
                        <ng-template #otherPrefEditElse>
                            <mat-form-field class="full-width">
                                <mat-label class="add-text-input">{{content?.['b2b.managetraveler.addotherpref']
                                    + ' (Optional)'}}</mat-label>
                                <mat-icon *ngIf="preferenceinfoForm.get('otherPref')?.value && !Loader.isEditableClicked" fontSet="material-symbols-outlined" matSuffix class="close-icon" style="cursor: pointer; font-size: 20px; width: 20px; height: 20px;" (click)="$event.stopPropagation(); preferenceinfoForm.get('otherPref')?.setValue('')">close</mat-icon>
                                <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select"
                                    [ngStyle]="{color:preferenceinfoForm.get('otherPref')?.value ? 'green':'gray'}">stat_minus_1</mat-icon>
                                <input type="text" matInput formControlName="otherPref"
                                    [matAutocomplete]="autoPreferences" (focus)="showAllPreferences()"
                                    (keypress)="_CommonService.allowOnlyCharacters($event)">
                            </mat-form-field>
                        </ng-template>
                        <div class="chip-container" *ngIf="!!selectedPreferences.length"
                            [class.mt-10-px]="(Loader.isEditableClicked && !!selectedPreferences.length)">
                            <span class="chip" *ngFor="let preference of selectedPreferences">
                                {{ preference }}
                                <mat-icon fontSet="material-symbols-outlined" class="remove-icon" tabindex="0"
                                    role="button" (click)="removePreference(preference)"
                                    (keydown.enter)="removePreference(preference)"
                                    (keydown.space)="removePreference(preference); $event.preventDefault()">cancel</mat-icon>
                            </span>
                        </div>
                        <mat-autocomplete #autoPreferences="matAutocomplete"
                            (optionSelected)="selectPreference($event.option.value)">
                            <mat-option *ngFor="let option of commonObjPipes.otherPref.pipe"
                                [value]="option.SSRName"> {{ option.SSRName }} </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="inner-contentsection" formGroupName="prefLoyaltyPrograms"
            [class.view-disabled]="hasFormData && Loader.isEditableClicked">
            <h4 class="subheading">{{content?.['b2b.managetraveler.loyaltyprogram']}}</h4>
            <div class="">
                <div class="f-row two--ColLayout">
                    <div class="f-col">
                        <mat-form-field>
                            <mat-label>{{content?.['b2b.managetraveler.airline']}}</mat-label>
                            <input matInput formControlName="airlineCode" [readonly]="true"
                                (contextmenu)="_CommonService.disableRightClick($event)">
                        </mat-form-field>
                    </div>
                    <div class="f-col">
                        <mat-form-field>
                            <mat-label>{{content?.['b2b.managetraveler.efalfursanid']}}</mat-label>
                            <input matInput formControlName="loyaltyNumber"
                                (keypress)="_CommonService.blockInvalidCharacters($event)"
                                (paste)="_CommonService.onPasteBlocked($event)"
                                (contextmenu)="_CommonService.disableRightClick($event)">
                            <mat-error *ngIf="
                                    preferenceinfoForm.get('prefLoyaltyPrograms.loyaltyNumber')?.value &&
                                    preferenceinfoForm.get('prefLoyaltyPrograms.loyaltyNumber')?.hasError('invalidLength') &&
                                    (preferenceinfoForm.get('prefLoyaltyPrograms.loyaltyNumber')?.dirty 
                                    || preferenceinfoForm.get('prefLoyaltyPrograms.loyaltyNumber')?.touched)
                                ">
                                {{content?.['b2b.managetraveler.efalfursanid']?.split('/')[0] }} 10 digit
                                allowed only.
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="inner-action"
            *ngIf="(!hasFormData || !Loader.isEditableClicked)">
            <button mat-button class="button--secondary-small"
                (click)="Cancel()">{{content?.['b2b.managetraveler.cancel']}}</button>
            <button mat-button class="button--primary-small" [class.disabled]="Loader.isEditableClicked 
                    || preferenceinfoForm.invalid 
                    || !isFormChanged()" [disabled]="Loader.isEditableClicked 
                    || preferenceinfoForm.invalid 
                    || !isFormChanged()" (click)="savePreferences()">
                <mat-spinner class="button" *ngIf="Loader.isSpinner"></mat-spinner>
                {{content?.['b2b.managetraveler.save']}}
            </button>
        </div>
    </div>
</form>